import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, throwMatDialogContentAlreadyAttachedError } from '@angular/material';
import {ActivatedRoute, Router} from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { UserService } from '../../core/user.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-log-upload-modal',
  templateUrl: './log-upload-modal.component.html',
  styleUrls: ['./log-upload-modal.component.css']
})
export class LogUploadModalComponent implements OnInit {
  filesToUpload: Array<File> = [];
  obj:any;
  projectId: any;
  hostUrl;
  configAzure: any;
  activeStatusUserAnalytics: boolean;
  myFormUserAnalytics: any;
  configUserAnalysis: any;
  serverId: any;
  addLog: any;
  addStatus: any;
  isDb = false;
  logUpload  : boolean;
  logData: any;
  showUpload: boolean;
  uploaded: boolean;
  filetype:any;
  apkFile: File;
  value = '';
  logFormat: any;
  lfileName: any;
  constructor(private dialogRef: MatDialogRef<LogUploadModalComponent>,	
     	@Inject(MAT_DIALOG_DATA) public data: String,private http: HttpClient, private router: Router,
    
    private route: ActivatedRoute, private userService: UserService, private toastr: ToastrService,) {  
      this.myFormUserAnalytics = new FormGroup({
      client_email: new FormControl(''),
      private_key: new FormControl(''),
      view_id: new FormControl('')
      
    });}

  ngOnInit() {
    this.hostUrl=this.userService.getUrl();
    this.logData = this.data;
    this.projectId = localStorage.getItem("projectId");

    //this.configAzure = this.azureData.tabledata;
//     this.projectId = this.logData.projectId;
//     this.addLog = this.logData.addConfig;
//     this.showUpload = false;
//     this.uploaded = false;
//     this.http.get(encodeURI(this.hostUrl+'/configure/userConfig/' + this.projectId))
//     .subscribe(data => {
//     this.configUserAnalysis = data;
//     if(this.configUserAnalysis.client_email === "null"||this.configUserAnalysis.client_email === ""  &&
//         this.configUserAnalysis.private_key === "null" ||this.configUserAnalysis.private_key === "" &&
//         this.configUserAnalysis.view_id === "null" ||this.configUserAnalysis.view_id === "" ){
//         this.activeStatusUserAnalytics = true;
//         }else{
//     this.myFormUserAnalytics.controls.client_email.setValue(this.configUserAnalysis.client_email)
//     this.myFormUserAnalytics.controls.private_key.setValue(this.configUserAnalysis.private_key)
//     this.myFormUserAnalytics.controls.view_id.setValue(this.configUserAnalysis.view_id)
//         }
// });


  }
  onchangeAppRating(value) {
    console.log(value)
    this.logFormat = value;
  }
  uploadFile() {
    this.uploaded = false;
    this.showUpload = true;
    const formData: any = new FormData();
    const files: Array<File> = this.filesToUpload;

    for (let i = 0; i < files.length; i++) {
      formData.append('uploads[]', files[i], files[i]['name']);
      console.log(formData)
    }
    this.http.post(this.hostUrl + '/file/uploadLogFile/'+ this.projectId + '/' + this.logFormat, formData)
      .subscribe(data => {
          console.log(formData)
          this.obj = JSON.parse(JSON.stringify(data));
          this.showUpload = false;
          this.uploaded = true;
      });
  }
  fileChangeEvent(fileInput: any) {
    this.filesToUpload = <Array<File>>fileInput.target.files;
    console.log(this.filesToUpload)
    let lfile = fileInput.target.files[0];
    this.lfileName = lfile.name;
    
    //   const file: File = this.filesToUpload[0];
    //   this.apkFile = file;
    //   this.filetype = this.apkFile.type;
    // console.log(file,this.apkFile,this.filetype)
    // if (this.filetype !== 'application/vnd.android.package-archive') {

    //   alert(this.filetype);
      
   // }

  }
  // fileChange(event) {
  //   const fileList: FileList = event.target.files;
  //   if (fileList.length > 0) {
  //     const file: File = fileList[0];
  //     this.apkFile = file;
  //     this.filetype = this.apkFile.type;
  //   }
  //   if (this.filetype !== 'application/vnd.android.package-archive') {

  //     this.alertService.showAlert('error', 'Not a valid apk file');
  //     this.apkFile = undefined;
  //   }
  // }
  onSubmitUserAnalytics(form: FormGroup) {
    let headers = new HttpHeaders();
     headers = headers.append('Content-Type', 'application/json');
     this.http.post(encodeURI(this.hostUrl+'/configure/updateuserAnalytics/' + this.projectId), form.value, {headers: headers})
        .subscribe(()=> {
          this.toastr.success('Submitted Successfully', 'Success ', {
            timeOut: 2000
          });
          // if (data['status'] === 200 || data['status'] === 201){

          // }
         });
   }

}



// WEBPACK FOOTER //
// ./src/app/_models/log-upload-modal/log-upload-modal.component.ts